import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import customizeHomepageUseCase from '../factories/customizeHomepage';

export const useCreateHomepageSection = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: customizeHomepageUseCase.create,
    onSuccess: () => {
      // Invalidate and refetch homepage configuration after successful creation
      queryClient.invalidateQueries({ queryKey: ['homepageConfiguration'] });
    },
    onError: (error) => {
      console.error('Failed to create homepage configuration:', error);
    },
  });

  return mutation;
};

export const useGetHomepageConfiguration = (options = {}) => {
  const query = useQuery({
    queryKey: ['homepageConfiguration'],
    queryFn: customizeHomepageUseCase.get,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    ...options,
  });

  return query;
};

export const useDeleteHomepageSection = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: customizeHomepageUseCase.deleteSection,
    onSuccess: () => {
      // Invalidate and refetch homepage configuration after successful deletion
      queryClient.invalidateQueries({ queryKey: ['homepageConfiguration'] });
    },
    onError: (error) => {
      console.error('Failed to delete homepage section:', error);
    },
  });

  return mutation;
};

export const useSortHomepageSections = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: customizeHomepageUseCase.sortSections,
    onSuccess: () => {
      // Invalidate and refetch homepage configuration after successful reordering
      queryClient.invalidateQueries({ queryKey: ['homepageConfiguration'] });
    },
    onError: (error) => {
      console.error('Failed to reorder homepage sections:', error);
    },
  });

  return mutation;
};

export const useUpdateHomepageSection = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ sectionId, payload }) =>
      customizeHomepageUseCase.updateSection(sectionId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['homepageConfiguration'] });
    },
    onError: (error) => {
      console.error('Failed to update homepage section:', error);
    },
  });

  return mutation;
};

export const useUpdateHomepageSectionActiveState = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ sectionId, isActive }) =>
      customizeHomepageUseCase.updateSectionActiveState(sectionId, isActive),
    onSuccess: () => {
      // Invalidate and refetch homepage configuration after successful update
      queryClient.invalidateQueries({ queryKey: ['homepageConfiguration'] });
    },
    onError: (error) => {
      console.error('Failed to update homepage section active state:', error);
    },
  });
  return mutation;
};
